export const SEMEADOR_ADUBADOR = {
    Codigo: 14,
    Nome: 'Semeador Adubador',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Size: "auto 80%", 
            Url: "assets/IPB/Produtos/Semeador_Adubador/semeador_1.png"
        },
        {
            Url: "assets/IPB/Produtos/Semeador_Adubador/semeador_2.png"
        },
        {
            Url: "assets/IPB/Produtos/Semeador_Adubador/semeador_3.png"
        }
    ],
    Detalhes: [
        `Distribuidor de uréia, adubo, semente e calcário`,
        `Prato, pás e defletor em INOX`,
        `Distribuição homogênea`,
        `Transmissão INPEL`,
        `Opcional com uma ou duas saídas`
    ],
    Modelos: [
        { Modelo: `GIR-600` },
        { Modelo: `GIR-700` }
    ]
}